import { FC } from "react";

import { DynamicInputProps } from "../types";



const DateFieldComp: FC<DynamicInputProps> = ({ label, name, value, data_required, render_condition, display, isHidden, id, group, state, updateValue }): JSX.Element => {
  return display ? (
    <div className={`form-group row py-3 ${render_condition !== "" && "bg-light"} ${isHidden ? "d-none" : ""}`}>
      <label htmlFor={name} className="col-sm-4 form-label text-end precert-form-label">
        {label} {data_required && "*"}
      </label>
      <div className="col-sm-8">
        <input
          type="date"
          className="form-control"
          name={name} id={name}
          required={data_required}
          value={state[name]}
          onChange={(e) => updateValue(e.target.value, id, group)}
        />
      </div>
    </div>
  ) : <></>;
}

export default DateFieldComp;
